const d = "onesignal-sdk", l = "https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js";
let u = !1, s = !1;
typeof window < "u" && (window.OneSignalDeferred = window.OneSignalDeferred || []);
function f() {
  s = !0;
}
function c(i) {
  if (document.getElementById(d))
    return;
  const e = document.createElement("script");
  e.id = d, e.defer = !0, e.src = i || l, e.onerror = () => {
    f();
  }, document.head.appendChild(e);
}
function w() {
  return g() || S();
}
function p() {
  return window.top !== window && // isContextIframe
  navigator.vendor === "Apple Computer, Inc." && // isSafari
  navigator.platform === "MacIntel";
}
function S() {
  return window.safari && typeof window.safari.pushNotification < "u" || p();
}
function g() {
  return typeof PushSubscriptionOptions < "u" && PushSubscriptionOptions.prototype.hasOwnProperty("applicationServerKey");
}
const m = () => w(), h = (i) => {
  var e;
  return u ? Promise.reject("OneSignal is already initialized.") : !i || !i.appId ? Promise.reject("You need to provide your OneSignal appId.") : document ? (((e = i.welcomeNotification) == null ? void 0 : e.disabled) !== void 0 && (i.welcomeNotification.disable = i.welcomeNotification.disabled), c(i.scriptSrc), new Promise((n, r) => {
    var t;
    (t = window.OneSignalDeferred) == null || t.push((o) => {
      o.init(i).then(() => {
        u = !0, n();
      }).catch(r);
    });
  })) : Promise.reject("Document is not defined.");
};
function O(i, e) {
  return new Promise((n, r) => {
    var t;
    if (s) {
      r(new Error("OneSignal script failed to load."));
      return;
    }
    (t = window.OneSignalDeferred) == null || t.push((o) => {
      o.login(i, e).then(() => n()).catch((a) => r(a));
    });
  });
}
function v() {
  return new Promise((i, e) => {
    var n;
    if (s) {
      e(new Error("OneSignal script failed to load."));
      return;
    }
    (n = window.OneSignalDeferred) == null || n.push((r) => {
      r.logout().then(() => i()).catch((t) => e(t));
    });
  });
}
function E(i) {
  return new Promise((e, n) => {
    var r;
    if (s) {
      n(new Error("OneSignal script failed to load."));
      return;
    }
    (r = window.OneSignalDeferred) == null || r.push((t) => {
      t.setConsentGiven(i).then(() => e()).catch((o) => n(o));
    });
  });
}
function D(i) {
  return new Promise((e, n) => {
    var r;
    if (s) {
      n(new Error("OneSignal script failed to load."));
      return;
    }
    (r = window.OneSignalDeferred) == null || r.push((t) => {
      t.setConsentRequired(i).then(() => e()).catch((o) => n(o));
    });
  });
}
function P(i) {
  return new Promise((e, n) => {
    var r;
    if (s) {
      n(new Error("OneSignal script failed to load."));
      return;
    }
    (r = window.OneSignalDeferred) == null || r.push((t) => {
      t.Slidedown.promptPush(i).then(() => e()).catch((o) => n(o));
    });
  });
}
function L(i) {
  return new Promise((e, n) => {
    var r;
    if (s) {
      n(new Error("OneSignal script failed to load."));
      return;
    }
    (r = window.OneSignalDeferred) == null || r.push((t) => {
      t.Slidedown.promptPushCategories(i).then(() => e()).catch((o) => n(o));
    });
  });
}
function U(i) {
  return new Promise((e, n) => {
    var r;
    if (s) {
      n(new Error("OneSignal script failed to load."));
      return;
    }
    (r = window.OneSignalDeferred) == null || r.push((t) => {
      t.Slidedown.promptSms(i).then(() => e()).catch((o) => n(o));
    });
  });
}
function A(i) {
  return new Promise((e, n) => {
    var r;
    if (s) {
      n(new Error("OneSignal script failed to load."));
      return;
    }
    (r = window.OneSignalDeferred) == null || r.push((t) => {
      t.Slidedown.promptEmail(i).then(() => e()).catch((o) => n(o));
    });
  });
}
function N(i) {
  return new Promise((e, n) => {
    var r;
    if (s) {
      n(new Error("OneSignal script failed to load."));
      return;
    }
    (r = window.OneSignalDeferred) == null || r.push((t) => {
      t.Slidedown.promptSmsAndEmail(i).then(() => e()).catch((o) => n(o));
    });
  });
}
function b(i, e) {
  var n;
  (n = window.OneSignalDeferred) == null || n.push((r) => {
    r.Slidedown.addEventListener(i, e);
  });
}
function T(i, e) {
  var n;
  (n = window.OneSignalDeferred) == null || n.push((r) => {
    r.Slidedown.removeEventListener(i, e);
  });
}
function I(i) {
  return new Promise((e, n) => {
    var r;
    if (s) {
      n(new Error("OneSignal script failed to load."));
      return;
    }
    (r = window.OneSignalDeferred) == null || r.push((t) => {
      t.Notifications.setDefaultUrl(i).then(() => e()).catch((o) => n(o));
    });
  });
}
function R(i) {
  return new Promise((e, n) => {
    var r;
    if (s) {
      n(new Error("OneSignal script failed to load."));
      return;
    }
    (r = window.OneSignalDeferred) == null || r.push((t) => {
      t.Notifications.setDefaultTitle(i).then(() => e()).catch((o) => n(o));
    });
  });
}
function C() {
  return new Promise((i, e) => {
    var n;
    if (s) {
      e(new Error("OneSignal script failed to load."));
      return;
    }
    (n = window.OneSignalDeferred) == null || n.push((r) => {
      r.Notifications.requestPermission().then((t) => i(t)).catch((t) => e(t));
    });
  });
}
function y(i, e) {
  var n;
  (n = window.OneSignalDeferred) == null || n.push((r) => {
    r.Notifications.addEventListener(i, e);
  });
}
function q(i, e) {
  var n;
  (n = window.OneSignalDeferred) == null || n.push((r) => {
    r.Notifications.removeEventListener(i, e);
  });
}
function k(i, e) {
  return new Promise((n, r) => {
    var t;
    if (s) {
      r(new Error("OneSignal script failed to load."));
      return;
    }
    (t = window.OneSignalDeferred) == null || t.push((o) => {
      o.Session.sendOutcome(i, e).then(() => n()).catch((a) => r(a));
    });
  });
}
function G(i) {
  return new Promise((e, n) => {
    var r;
    if (s) {
      n(new Error("OneSignal script failed to load."));
      return;
    }
    (r = window.OneSignalDeferred) == null || r.push((t) => {
      t.Session.sendUniqueOutcome(i).then(() => e()).catch((o) => n(o));
    });
  });
}
function K(i, e) {
  var n;
  (n = window.OneSignalDeferred) == null || n.push((r) => {
    r.User.addAlias(i, e);
  });
}
function _(i) {
  var e;
  (e = window.OneSignalDeferred) == null || e.push((n) => {
    n.User.addAliases(i);
  });
}
function x(i) {
  var e;
  (e = window.OneSignalDeferred) == null || e.push((n) => {
    n.User.removeAlias(i);
  });
}
function V(i) {
  var e;
  (e = window.OneSignalDeferred) == null || e.push((n) => {
    n.User.removeAliases(i);
  });
}
function z(i) {
  var e;
  (e = window.OneSignalDeferred) == null || e.push((n) => {
    n.User.addEmail(i);
  });
}
function F(i) {
  var e;
  (e = window.OneSignalDeferred) == null || e.push((n) => {
    n.User.removeEmail(i);
  });
}
function M(i) {
  var e;
  (e = window.OneSignalDeferred) == null || e.push((n) => {
    n.User.addSms(i);
  });
}
function B(i) {
  var e;
  (e = window.OneSignalDeferred) == null || e.push((n) => {
    n.User.removeSms(i);
  });
}
function Y(i, e) {
  var n;
  (n = window.OneSignalDeferred) == null || n.push((r) => {
    r.User.addTag(i, e);
  });
}
function H(i) {
  var e;
  (e = window.OneSignalDeferred) == null || e.push((n) => {
    n.User.addTags(i);
  });
}
function J(i) {
  var e;
  (e = window.OneSignalDeferred) == null || e.push((n) => {
    n.User.removeTag(i);
  });
}
function Q(i) {
  var e;
  (e = window.OneSignalDeferred) == null || e.push((n) => {
    n.User.removeTags(i);
  });
}
async function W() {
  var e;
  let i;
  return await ((e = window.OneSignalDeferred) == null ? void 0 : e.push((n) => {
    i = n.User.getTags();
  })), i;
}
function X(i, e) {
  var n;
  (n = window.OneSignalDeferred) == null || n.push((r) => {
    r.User.addEventListener(i, e);
  });
}
function Z(i, e) {
  var n;
  (n = window.OneSignalDeferred) == null || n.push((r) => {
    r.User.removeEventListener(i, e);
  });
}
function $(i) {
  var e;
  (e = window.OneSignalDeferred) == null || e.push((n) => {
    n.User.setLanguage(i);
  });
}
async function j() {
  var e;
  let i;
  return await ((e = window.OneSignalDeferred) == null ? void 0 : e.push((n) => {
    i = n.User.getLanguage();
  })), i;
}
function ee(i, e) {
  var n;
  (n = window.OneSignalDeferred) == null || n.push((r) => {
    r.User.trackEvent(i, e);
  });
}
function ne() {
  return new Promise((i, e) => {
    var n;
    if (s) {
      e(new Error("OneSignal script failed to load."));
      return;
    }
    (n = window.OneSignalDeferred) == null || n.push((r) => {
      r.User.PushSubscription.optIn().then(() => i()).catch((t) => e(t));
    });
  });
}
function ie() {
  return new Promise((i, e) => {
    var n;
    if (s) {
      e(new Error("OneSignal script failed to load."));
      return;
    }
    (n = window.OneSignalDeferred) == null || n.push((r) => {
      r.User.PushSubscription.optOut().then(() => i()).catch((t) => e(t));
    });
  });
}
function re(i, e) {
  var n;
  (n = window.OneSignalDeferred) == null || n.push((r) => {
    r.User.PushSubscription.addEventListener(i, e);
  });
}
function te(i, e) {
  var n;
  (n = window.OneSignalDeferred) == null || n.push((r) => {
    r.User.PushSubscription.removeEventListener(i, e);
  });
}
function oe(i) {
  var e;
  (e = window.OneSignalDeferred) == null || e.push((n) => {
    n.Debug.setLogLevel(i);
  });
}
const se = {
  get id() {
    var i, e, n;
    return (n = (e = (i = window.OneSignal) == null ? void 0 : i.User) == null ? void 0 : e.PushSubscription) == null ? void 0 : n.id;
  },
  get token() {
    var i, e, n;
    return (n = (e = (i = window.OneSignal) == null ? void 0 : i.User) == null ? void 0 : e.PushSubscription) == null ? void 0 : n.token;
  },
  get optedIn() {
    var i, e, n;
    return (n = (e = (i = window.OneSignal) == null ? void 0 : i.User) == null ? void 0 : e.PushSubscription) == null ? void 0 : n.optedIn;
  },
  optIn: ne,
  optOut: ie,
  addEventListener: re,
  removeEventListener: te
}, ae = {
  get onesignalId() {
    var i, e;
    return (e = (i = window.OneSignal) == null ? void 0 : i.User) == null ? void 0 : e.onesignalId;
  },
  get externalId() {
    var i, e;
    return (e = (i = window.OneSignal) == null ? void 0 : i.User) == null ? void 0 : e.externalId;
  },
  addAlias: K,
  addAliases: _,
  removeAlias: x,
  removeAliases: V,
  addEmail: z,
  removeEmail: F,
  addSms: M,
  removeSms: B,
  addTag: Y,
  addTags: H,
  removeTag: J,
  removeTags: Q,
  getTags: W,
  addEventListener: X,
  removeEventListener: Z,
  setLanguage: $,
  getLanguage: j,
  trackEvent: ee,
  PushSubscription: se
}, de = {
  sendOutcome: k,
  sendUniqueOutcome: G
}, ue = {
  setLogLevel: oe
}, le = {
  promptPush: P,
  promptPushCategories: L,
  promptSms: U,
  promptEmail: A,
  promptSmsAndEmail: N,
  addEventListener: b,
  removeEventListener: T
}, fe = {
  get permissionNative() {
    var i, e;
    return ((e = (i = window.OneSignal) == null ? void 0 : i.Notifications) == null ? void 0 : e.permissionNative) ?? "default";
  },
  get permission() {
    var i, e;
    return ((e = (i = window.OneSignal) == null ? void 0 : i.Notifications) == null ? void 0 : e.permission) ?? !1;
  },
  setDefaultUrl: I,
  setDefaultTitle: R,
  isPushSupported: m,
  requestPermission: C,
  addEventListener: y,
  removeEventListener: q
}, ce = {
  login: O,
  logout: v,
  init: h,
  setConsentGiven: E,
  setConsentRequired: D,
  Slidedown: le,
  Notifications: fe,
  Session: de,
  User: ae,
  Debug: ue
}, we = ce;
export {
  we as default
};
//# sourceMappingURL=index.js.map
